window.enhance.loadJS.ready(['jQuery'],
    {
        success: function () {
            $("#submitESDHFilter").on("click",
                function (e) { //todo
                    var baseUrl = $('.list__filter').attr('action');
                    var committeeSelectList = document.getElementById('list__filter--committee');
                    var yearSelectList = document.getElementById('list__filter--year');
                    var committeeName = committeeSelectList.options[committeeSelectList.selectedIndex]
                        .getAttribute('data-url');

                    var year = yearSelectList.options[yearSelectList.selectedIndex]
                        .getAttribute('data-url');

                    $('.list__filter').attr('action', baseUrl + committeeName + "/" + year + "/").submit();
                });

            mobileInjectAudioElement();
            console.log('esdh loaded');

            $(window).resize(function () {
                mobileInjectAudioElement();
            });


            function mobileInjectAudioElement() {

                var breakpoint = 768;
                var elementClass = ".esdh__audio";
                var element = $(".esdh__audio");
                var targetDesktop = $(".esdh__content--filter");
                var targetMobile = $(".esdh__content--mainContent");
                if (element.length !== 0) {
                    var elementContent = element[0].outerHTML;

                    if (window.innerWidth < breakpoint) {
                        console.log($(window).width());
                        if (targetMobile.find(elementClass).length == 0) {
                            element.remove();
                            targetMobile.after(elementContent);
                        }
                    } else {
                        console.log($(window).width());
                        if (targetDesktop.find(elementClass).length == 0) {
                            element.remove();
                            targetDesktop.after(elementContent);
                        }
                    }
                }
            }
        }
    });
